import { createFileRoute, stripSearchParams } from "@tanstack/react-router"
import { z } from "zod"
import { intentSchema } from "@/entities/user"
import { VerifyAgePage } from "@/pages/verify-age"

const searchDefaults = { intent: null } as const

const searchSchema = z.object({
	intent: intentSchema
		.nullable()
		.default(searchDefaults.intent)
		.catch(searchDefaults.intent),
})

export const Route = createFileRoute("/_authenticated/verify-age")({
	validateSearch: searchSchema,
	search: { middlewares: [stripSearchParams(searchDefaults)] },
	component: VerifyAgeRoute,
})

function VerifyAgeRoute() {
	const { intent } = Route.useSearch()
	return <VerifyAgePage intent={intent} />
}
